var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cn-product-card-skeleton"},[_c('UiSkeletonElement',{style:({
      width: '100%',
      aspectRatio: '1 / 1',
    })}),_vm._v(" "),_c('UiSkeletonElement',{style:({
      width: '100%',
      height: '44px',
      marginTop: 'calc(var(--size-base) / 2)',
    })}),_vm._v(" "),_c('div',{style:({
      justifyContent: 'space-between',
      display: 'flex',
      marginTop: 'var(--size-base)',
    })},[_c('UiSkeletonElement',{style:({
        width: '33.333333%',
        height: '20px',
      })}),_vm._v(" "),_c('UiSkeletonElement',{style:({
        width: '25%',
        height: '20px',
      })})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }